package ru.chm.gradereport.ui.components

import androidx.compose.foundation.ScrollState
import androidx.compose.foundation.gestures.scrollBy
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Modifier
import androidx.compose.ui.composed
import androidx.compose.ui.input.pointer.PointerEventPass
import androidx.compose.ui.input.pointer.PointerEventType
import androidx.compose.ui.input.pointer.pointerInput
import kotlinx.coroutines.launch
import kotlin.math.abs

/** Maps vertical mouse-wheel scroll to horizontal scrolling (no Shift needed). */
fun Modifier.horizontalScrollOnWheel(scrollState: ScrollState): Modifier = composed {
    val scope = rememberCoroutineScope()
    pointerInput(scrollState) {
        awaitPointerEventScope {
            while (true) {
                val event = awaitPointerEvent(PointerEventPass.Main)
                if (event.type != PointerEventType.Scroll) continue
                val change = event.changes.firstOrNull() ?: continue
                val delta = change.scrollDelta
                val amount = if (abs(delta.y) >= abs(delta.x)) delta.y else delta.x
                if (amount == 0f) continue
                scope.launch { scrollState.scrollBy(amount) }
                change.consume()
            }
        }
    }
}
